import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { COMPANY, waLink } from "@/data/company";

export const CtaSection = ({ titulo, texto, waMsg }) => (
  <section className="bg-brand-red text-white rounded-2xl px-6 md:px-12 py-10 md:py-14 my-12 text-center relative overflow-hidden" data-testid="cta-section">
    <div className="absolute -top-6 -right-6 w-28 h-28 rounded-full bg-brand-yellow text-brand-dark font-heading font-black flex items-center justify-center rotate-12 text-center leading-tight text-sm shadow-xl">
      24H<br />TODOS<br />OS DIAS
    </div>
    <h2 className="font-heading font-black text-2xl md:text-4xl uppercase tracking-tight mb-3">{titulo}</h2>
    <p className="text-white/90 max-w-2xl mx-auto mb-7 text-sm md:text-base">{texto}</p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <a href={waLink(waMsg)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-greenHover text-white font-heading font-bold px-8 py-4 rounded-full text-base transition-transform hover:scale-105" data-testid="cta-whatsapp-btn">
        <WhatsAppIcon /> Chamar no WhatsApp
      </a>
      <a href={`tel:${COMPANY.telefoneRaw}`} className="inline-flex items-center justify-center gap-2 bg-brand-dark hover:bg-black text-white font-heading font-bold px-8 py-4 rounded-full text-base transition-transform hover:scale-105" data-testid="cta-call-btn">
        <Phone size={18} /> {COMPANY.telefone}
      </a>
    </div>
  </section>
);
